import { render, staticRenderFns } from "./SidebarContainer.vue?vue&type=template&id=b530b1f0&scoped=true&"
import script from "./SidebarContainer.vue?vue&type=script&lang=js&"
export * from "./SidebarContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b530b1f0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/fiksucity/city-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b530b1f0')) {
      api.createRecord('b530b1f0', component.options)
    } else {
      api.reload('b530b1f0', component.options)
    }
    module.hot.accept("./SidebarContainer.vue?vue&type=template&id=b530b1f0&scoped=true&", function () {
      api.rerender('b530b1f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sidebar/SidebarContainer.vue"
export default component.exports